"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PropertyMapping {
    /**
     * Initializes a new instance of the {@link PropertyMapping} class.
     * @param {MappingsBuilder} builder Mappings builder.
     * @param {IDictionary<string>} result Current property mappings.
     * @param {IIriTemplateMapping} mapping IRI template mapping.
     */
    constructor(builder, result, mapping) {
        this.builder = builder;
        this.result = result;
        this.mapping = mapping;
    }
    /**
     * Allows to map a value to a variable mapping.
     * @param {string} value Value to be used.
     * @returns {MappingsBuilder}
     */
    havingValueOf(value) {
        this.result[this.mapping.variable] = value;
        return this.builder;
    }
}
exports.default = PropertyMapping;
//# sourceMappingURL=PropertyMapping.js.map